import { render, staticRenderFns } from "./ExpensesTab.vue?vue&type=template&id=d9291f82&scoped=true"
import script from "./ExpensesTab.vue?vue&type=script&lang=js"
export * from "./ExpensesTab.vue?vue&type=script&lang=js"
import style0 from "./ExpensesTab.vue?vue&type=style&index=0&id=d9291f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9291f82",
  null
  
)

export default component.exports